module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "8ad3":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9205":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductCarousel_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8ad3");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductCarousel_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductCarousel_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductCarousel_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "f6fd":
/***/ (function(module, exports) {

// document.currentScript polyfill by Adam Miller

// MIT license

(function(document){
  var currentScript = "currentScript",
      scripts = document.getElementsByTagName('script'); // Live NodeList collection

  // If browser needs currentScript polyfill, add get currentScript() to the document object
  if (!(currentScript in document)) {
    Object.defineProperty(document, currentScript, {
      get: function(){

        // IE 6-10 supports script readyState
        // IE 10+ support stack trace
        try { throw new Error(); }
        catch (err) {

          // Find the second match for the "at" string to get file src url from stack.
          // Specifically works with the format of stack traces in IE.
          var i, res = ((/.*at [^\(]*\((.*):.+:.+\)$/ig).exec(err.stack) || [false])[1];

          // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
          for(i in scripts){
            if(scripts[i].src == res || scripts[i].readyState == "interactive"){
              return scripts[i];
            }
          }

          // If no match, return null
          return null;
        }
      }
    });
  }
})(document);


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  if (true) {
    __webpack_require__("f6fd")
  }

  var i
  if ((i = window.document.currentScript) && (i = i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __webpack_require__.p = i[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"65d438da-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ProductCarousel.vue?vue&type=template&id=c84cc3ac&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-product-carousel",class:{'zoomed':_vm.isZoomed}},[_c('div',{staticClass:"block-image"},[_c('a',{staticClass:"main-image responsive-image",class:{'background-loading':_vm.bgLoading},style:(_vm.mainImageStyle),attrs:{"href":"#"},on:{"click":_vm.toggleZoom,"mousemove":_vm.onMouseMove}}),_c('div',{ref:"swipeWrap",staticClass:"block-image-carousel swipe",attrs:{"id":"product-slider"}},[_c('div',{staticClass:"swipe-wrap"},_vm._l((_vm.images),function(image,index){return _c('div',{key:index},[_c('a',{staticClass:"swipe-thumbnail",class:{
                'selected'          : index === _vm.next,
                'background-loading': _vm.itemsBgLoading
               },style:(_vm.bgi(image)),attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onSlideClick(index)}}})])}),0)]),_c('div',{staticClass:"swipe-dots"},_vm._l((_vm.images),function(image,index){return _c('a',{key:index,staticClass:"btn-swipe",class:{'selected': index === _vm.next},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onSlideClick(index)}}},[_vm._v(_vm._s(index))])}),0)]),_c('div',{staticClass:"block-details"},[_vm._t("default")],2)])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ProductCarousel.vue?vue&type=template&id=c84cc3ac&

// CONCATENATED MODULE: ./src/vendor/swipe.js
/*
 * Swipe 2.0
 *
 * Brad Birdsall
 * Copyright 2013, MIT License
 *
*/
function Swipe(container, options) {
  // utilities
  var noop = function noop() {}; // simple no operation function


  var offloadFn = function offloadFn(fn) {
    setTimeout(fn || noop, 0);
  }; // offload a functions execution
  // check browser capabilities


  var browser = {
    addEventListener: !!window.addEventListener,
    touch: 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch,
    transitions: function (temp) {
      var props = ['transitionProperty', 'WebkitTransition', 'MozTransition', 'OTransition', 'msTransition'];

      for (var i in props) {
        if (temp.style[props[i]] !== undefined) return true;
      }

      return false;
    }(document.createElement('swipe'))
  }; // quit if no root element

  if (!container) return;
  var element = container.children[0];
  var slides;
  var slidePos;
  var width;
  var length;
  options = options || {};
  var index = parseInt(options.startSlide, 10) || 0;
  var speed = options.speed || 300;
  options.continuous = options.continuous !== undefined ? options.continuous : true;

  function setup() {
    // cache slides
    slides = element.children;
    length = slides.length; // set continuous to false if only one slide

    if (slides.length < 2) options.continuous = false; // special case if two slides

    if (browser.transitions && options.continuous && slides.length < 3) {
      element.appendChild(slides[0].cloneNode(true));
      element.appendChild(element.children[1].cloneNode(true));
      slides = element.children;
    } // create an array to store current positions of each slide


    slidePos = new Array(slides.length); // determine width of each slide
    // IMPORTANT: Please forgive me for editing vendor code...

    if (typeof jQuery !== 'undefined') {
      width = jQuery(container).outerWidth();
    } else {
      width = container.getBoundingClientRect().width || container.offsetWidth;
    }

    element.style.width = "".concat(slides.length * width, "px"); // stack elements

    var pos = slides.length;

    while (pos--) {
      var _slide = slides[pos];
      _slide.style.width = "".concat(width, "px");

      _slide.setAttribute('data-index', pos);

      if (browser.transitions) {
        _slide.style.left = "".concat(pos * -width, "px");
        move(pos, index > pos ? -width : index < pos ? width : 0, 0);
      }
    } // reposition elements before and after index


    if (options.continuous && browser.transitions) {
      move(circle(index - 1), -width, 0);
      move(circle(index + 1), width, 0);
    }

    if (!browser.transitions) element.style.left = "".concat(index * -width, "px");
    container.style.visibility = 'visible';
  }

  function _prev() {
    if (options.continuous) _slide2(index - 1);else if (index) _slide2(index - 1);
  }

  function _next() {
    if (options.continuous) _slide2(index + 1);else if (index < slides.length - 1) _slide2(index + 1);
  }

  function circle(index) {
    // a simple positive modulo using slides.length
    return (slides.length + index % slides.length) % slides.length;
  }

  function _slide2(to, slideSpeed) {
    // do nothing if already on requested slide
    if (index == to) return;

    if (browser.transitions) {
      var direction = Math.abs(index - to) / (index - to); // 1: backward, -1: forward
      // get the actual position of the slide

      if (options.continuous) {
        var natural_direction = direction;
        direction = -slidePos[circle(to)] / width; // if going forward but to < index, use to = slides.length + to
        // if going backward but to > index, use to = -slides.length + to

        if (direction !== natural_direction) to = -direction * slides.length + to;
      }

      var diff = Math.abs(index - to) - 1; // move all the slides between index and to in the right direction

      while (diff--) {
        move(circle((to > index ? to : index) - diff - 1), width * direction, 0);
      }

      to = circle(to);
      move(index, width * direction, slideSpeed || speed);
      move(to, 0, slideSpeed || speed);
      if (options.continuous) move(circle(to - direction), -(width * direction), 0); // we need to get the next in place
    } else {
      to = circle(to);
      animate(index * -width, to * -width, slideSpeed || speed); // no fallback for a circular continuous if the browser does not accept transitions
    }

    index = to;
    offloadFn(options.callback && options.callback(index, slides[index]));
  }

  function move(index, dist, speed) {
    translate(index, dist, speed);
    slidePos[index] = dist;
  }

  function translate(index, dist, speed) {
    var slide = slides[index];
    var style = slide && slide.style;
    if (!style) return;
    style.webkitTransitionDuration = style.MozTransitionDuration = style.msTransitionDuration = style.OTransitionDuration = style.transitionDuration = "".concat(speed, "ms");
    style.webkitTransform = "translate(".concat(dist, "px,0)") + 'translateZ(0)';
    style.msTransform = style.MozTransform = style.OTransform = "translateX(".concat(dist, "px)");
  }

  function animate(from, to, speed) {
    // if not an animation, just reposition
    if (!speed) {
      element.style.left = "".concat(to, "px");
      return;
    }

    var start = +new Date();
    var timer = setInterval(function () {
      var timeElap = +new Date() - start;

      if (timeElap > speed) {
        element.style.left = "".concat(to, "px");
        if (delay) begin();
        options.transitionEnd && options.transitionEnd.call(event, index, slides[index]);
        clearInterval(timer);
        return;
      }

      element.style.left = "".concat((to - from) * (Math.floor(timeElap / speed * 100) / 100) + from, "px");
    }, 4);
  } // setup auto slideshow


  var delay = options.auto || 0;
  var interval;

  function begin() {
    interval = setTimeout(_next, delay);
  }

  function stop() {
    delay = 0;
    clearTimeout(interval);
  } // setup initial vars


  var _start = {};
  var delta = {};
  var isScrolling; // setup event capturing

  var events = {
    handleEvent: function handleEvent(event) {
      switch (event.type) {
        case 'touchstart':
          this.start(event);
          break;

        case 'touchmove':
          this.move(event);
          break;

        case 'touchend':
          offloadFn(this.end(event));
          break;

        case 'webkitTransitionEnd':
        case 'msTransitionEnd':
        case 'oTransitionEnd':
        case 'otransitionend':
        case 'transitionend':
          offloadFn(this.transitionEnd(event));
          break;

        case 'resize':
          offloadFn(setup);
          break;
      }

      if (options.stopPropagation) event.stopPropagation();
    },
    start: function start(event) {
      var touches = event.touches[0]; // measure start values

      _start = {
        // get initial touch coords
        x: touches.pageX,
        y: touches.pageY,
        // store time to determine touch duration
        time: +new Date()
      }; // used for testing first move event

      isScrolling = undefined; // reset delta and end measurements

      delta = {}; // attach touchmove and touchend listeners

      element.addEventListener('touchmove', this, false);
      element.addEventListener('touchend', this, false);
    },
    move: function move(event) {
      // ensure swiping with one touch and not pinching
      if (event.touches.length > 1 || event.scale && event.scale !== 1) return;
      if (options.disableScroll) event.preventDefault();
      var touches = event.touches[0]; // measure change in x and y

      delta = {
        x: touches.pageX - _start.x,
        y: touches.pageY - _start.y
      }; // determine if scrolling test has run - one time test

      if (typeof isScrolling === 'undefined') {
        isScrolling = !!(isScrolling || Math.abs(delta.x) < Math.abs(delta.y));
      } // if user is not trying to scroll vertically


      if (!isScrolling) {
        // prevent native scrolling
        event.preventDefault(); // stop slideshow

        stop(); // increase resistance if first or last slide

        if (options.continuous) {
          // we don't add resistance at the end
          translate(circle(index - 1), delta.x + slidePos[circle(index - 1)], 0);
          translate(index, delta.x + slidePos[index], 0);
          translate(circle(index + 1), delta.x + slidePos[circle(index + 1)], 0);
        } else {
          delta.x /= !index && delta.x > 0 // if first slide and sliding left
          || index == slides.length - 1 // or if last slide and sliding right
          && delta.x < 0 // and if sliding at all
          ? Math.abs(delta.x) / width + 1 : // determine resistance level
          1; // no resistance if false
          // translate 1:1

          translate(index - 1, delta.x + slidePos[index - 1], 0);
          translate(index, delta.x + slidePos[index], 0);
          translate(index + 1, delta.x + slidePos[index + 1], 0);
        }
      }
    },
    end: function end(event) {
      // measure duration
      var duration = +new Date() - _start.time; // determine if slide attempt triggers next/prev slide

      var isValidSlide = Number(duration) < 250 // if slide duration is less than 250ms
      && Math.abs(delta.x) > 20 // and if slide amt is greater than 20px
      || Math.abs(delta.x) > width / 2; // or if slide amt is greater than half the width
      // determine if slide attempt is past start and end

      var isPastBounds = !index && delta.x > 0 // if first slide and slide amt is greater than 0
      || index == slides.length - 1 && delta.x < 0; // or if last slide and slide amt is less than 0

      if (options.continuous) isPastBounds = false; // determine direction of swipe (true:right, false:left)

      var direction = delta.x < 0; // if not scrolling vertically

      if (!isScrolling) {
        if (isValidSlide && !isPastBounds) {
          if (direction) {
            if (options.continuous) {
              // we need to get the next in this direction in place
              move(circle(index - 1), -width, 0);
              move(circle(index + 2), width, 0);
            } else {
              move(index - 1, -width, 0);
            }

            move(index, slidePos[index] - width, speed);
            move(circle(index + 1), slidePos[circle(index + 1)] - width, speed);
            index = circle(index + 1);
          } else {
            if (options.continuous) {
              // we need to get the next in this direction in place
              move(circle(index + 1), width, 0);
              move(circle(index - 2), -width, 0);
            } else {
              move(index + 1, width, 0);
            }

            move(index, slidePos[index] + width, speed);
            move(circle(index - 1), slidePos[circle(index - 1)] + width, speed);
            index = circle(index - 1);
          }

          options.callback && options.callback(index, slides[index]);
        } else if (options.continuous) {
          move(circle(index - 1), -width, speed);
          move(index, 0, speed);
          move(circle(index + 1), width, speed);
        } else {
          move(index - 1, -width, speed);
          move(index, 0, speed);
          move(index + 1, width, speed);
        }
      } // kill touchmove and touchend event listeners until touchstart called again


      element.removeEventListener('touchmove', events, false);
      element.removeEventListener('touchend', events, false);
    },
    transitionEnd: function transitionEnd(event) {
      if (parseInt(event.target.getAttribute('data-index'), 10) == index) {
        if (delay) begin();
        options.transitionEnd && options.transitionEnd.call(event, index, slides[index]);
      }
    }
  }; // trigger setup

  setup(); // start auto slideshow if applicable

  if (delay) begin(); // add event listeners

  if (browser.addEventListener) {
    // set touchstart event on element
    if (browser.touch) element.addEventListener('touchstart', events, false);

    if (browser.transitions) {
      element.addEventListener('webkitTransitionEnd', events, false);
      element.addEventListener('msTransitionEnd', events, false);
      element.addEventListener('oTransitionEnd', events, false);
      element.addEventListener('otransitionend', events, false);
      element.addEventListener('transitionend', events, false);
    } // set resize event on window


    window.addEventListener('resize', events, false);
  } else {
    window.onresize = function () {
      setup();
    }; // to play nice with old IE

  } // expose the Swipe API


  return {
    setup: setup,
    slide: function slide(to, speed) {
      // cancel slideshow
      stop();

      _slide2(to, speed);
    },
    prev: function prev() {
      // cancel slideshow
      stop();

      _prev();
    },
    next: function next() {
      // cancel slideshow
      stop();

      _next();
    },
    // cancel slideshow
    stop: stop,
    // return current index position
    getPos: function getPos() {
      return index;
    },
    // return total number of slides
    getNumSlides: function getNumSlides() {
      return length;
    },
    kill: function kill() {
      // cancel slideshow
      stop(); // reset element

      element.style.width = '';
      element.style.left = ''; // reset slides

      var pos = slides.length;

      while (pos--) {
        var slide = slides[pos];
        slide.style.width = '';
        slide.style.left = '';
        if (browser.transitions) translate(pos, 0, 0);
      } // removed event listeners


      if (!browser.addEventListener) {
        window.onresize = null;
        return;
      } // remove current event listeners


      element.removeEventListener('touchstart', events, false);
      element.removeEventListener('webkitTransitionEnd', events, false);
      element.removeEventListener('msTransitionEnd', events, false);
      element.removeEventListener('oTransitionEnd', events, false);
      element.removeEventListener('otransitionend', events, false);
      element.removeEventListener('transitionend', events, false);
      window.removeEventListener('resize', events, false);
    }
  };
}

/* harmony default export */ var swipe = (Swipe);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ProductCarousel.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ProductCarouselvue_type_script_lang_js_ = ({
  swipe: null,
  props: {
    images: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    bodyClassOnZoom: {
      type: String,
      required: false,
      default: 'zoom'
    }
  },
  data: function data() {
    return {
      // is Zoom mode active
      isZoomed: false,
      // background position in Zoom mode
      positionY: 50,
      // current slide id
      current: 0,
      // next slide id
      next: 0,
      // main image loading status
      bgLoading: true,
      // image pagination loading status
      itemsBgLoading: true,
      // is Swipe mode active
      swipeActive: false
    };
  },
  computed: {
    /**
     * Computed current slide image
     * @returns {?String}
     */
    currentSlide: function currentSlide() {
      return this.images[this.current];
    },

    /**
     * Computed zoom style for zoom mode
     * @returns {{backgroundPosition: string}}
     */
    currentZoomStyle: function currentZoomStyle() {
      return {
        backgroundPosition: "50% ".concat(this.positionY, "%")
      };
    },

    /**
     * Computed styles of main image
     */
    mainImageStyle: function mainImageStyle() {
      return Object.assign({}, this.currentZoomStyle, this.bgi(this.currentSlide));
    }
  },
  methods: {
    /**
     * Adds or removes body class based on zoom mode
     */
    updateBodyClass: function updateBodyClass() {
      // don't do anything if not class defined
      if (!this.bodyClassOnZoom) return;
      var body = document.querySelector('body');

      if (this.isZoomed) {
        body.classList.add(this.bodyClassOnZoom);
      } else {
        body.classList.remove(this.bodyClassOnZoom);
      }
    },

    /**
     * Toggles Zoom mode
     */
    toggleZoom: function toggleZoom() {
      this.isZoomed = !this.isZoomed; // add class to body if needed

      this.updateBodyClass();
    },

    /**
     * Calc position percentage
     * @returns {Number}
     */
    map: function map(value, start1, stop1, start2, stop2) {
      return start2 + (stop2 - start2) * ((value - start1) / (stop1 - start1));
    },

    /**
     * Fires on mouse move in Zoom mode
     */
    onMouseMove: function onMouseMove(e) {
      // prevent to call in non-zoom mode
      if (!this.isZoomed) return;
      this.positionY = this.map(e.clientY, 0, window.innerHeight, 0, 100);
    },

    /**
     * Fires on slide change in Swipe mode
     * @param {Number} index Changed slide index
     */
    onSwipe: function onSwipe(index) {
      this.next = index;
      this.smoothChange();
    },

    /**
     * Shortcut for Background Image in css
     */
    bgi: function bgi(url) {
      return {
        backgroundImage: "url('".concat(url, "')")
      };
    },

    /**
     * Fires on next slide click
     */
    onSlideClick: function onSlideClick(index) {
      // prevent change if slide already correct
      if (this.current === index || this.next === index) return;
      this.next = index;
      this.smoothChange(); // call slide in swipe mode (if needed)

      if (this.swipeActive) {
        this.$options.swipe.slide(index, 400);
      }
    },

    /**
     * Makes smooth change for current slide
     */
    smoothChange: function smoothChange() {
      var _this = this;

      this.bgLoading = true;
      setTimeout(function () {
        _this.current = _this.next;
        _this.bgLoading = false;
      }, 400);
    },

    /**
     * Makes smooth change for preview icons
     */
    smoothChangeItems: function smoothChangeItems() {
      var _this2 = this;

      this.itemsBgLoading = true;
      setTimeout(function () {
        _this2.itemsBgLoading = false;
      }, 400);
    },

    /**
     * Activates Swipe mode (if possible)
     */
    activateSwipe: function activateSwipe() {
      // prevent Swipe mode on big screens
      if (window.innerWidth > 1024) return; // use Swipe lib and save instance to $options

      this.$options.swipe = new swipe(this.$refs.swipeWrap, {
        speed: 400,
        continuous: true,
        disableScroll: false,
        stopPropagation: false,
        callback: this.onSwipe
      });
      this.swipeActive = true;
    }
  },
  watch: {
    isZoomed: function isZoomed(status) {
      // if zoom disabled -> move background back to center
      if (!status) {
        this.positionY = 50;
      }
    },
    images: function images() {
      // on images change -> gracefully move to the first slide
      this.onSlideClick(0);
    }
  },

  /**
   * Fires on component ready state
   */
  mounted: function mounted() {
    this.smoothChange();
    this.smoothChangeItems();
    this.activateSwipe();
  }
});
// CONCATENATED MODULE: ./src/components/ProductCarousel.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_ProductCarouselvue_type_script_lang_js_ = (ProductCarouselvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/ProductCarousel.vue?vue&type=style&index=0&lang=css&
var ProductCarouselvue_type_style_index_0_lang_css_ = __webpack_require__("9205");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/components/ProductCarousel.vue






/* normalize component */

var component = normalizeComponent(
  components_ProductCarouselvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ProductCarousel = (component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (ProductCarousel);



/***/ })

/******/ })["default"];
//# sourceMappingURL=VueProductCarousel.common.js.map